import { ApiService } from "src/network/apiService";
import { ICreateResellerRequest } from "./create-reseller";
import { IApiResponse } from "src/network/models/ApiResponse";

export class CreateResellerViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }


    async createResellerAsync(request: ICreateResellerRequest): Promise<boolean> {
        const URL = `/onboard/reseller`;
        const response = await this.apiService.postAsync<IApiResponse<boolean>, any>(
            URL, request);

        if (response && response.scResponse && response.scResponse.code === 2000) {
            return true;
        }

        return false;
    }
}